














































































































































































































































import Vue from 'vue';
import DropDown from '@/components/FormInputs/DropDown.vue';
import Upload from '@/components/FormInputs/Upload.vue';
import Checkbox from '@/components/FormInputs/Checkbox.vue';

export default Vue.extend({
  name: 'AdminUser',
  components: {
    DropDown,
    Upload,
    Checkbox,
  },
  data() {
    return {
      unternehmen: {},
      todelete: false,
    };
  },
  created() {
    this.$store.dispatch('loadUnternehmenById', this.uid).then((results: any) => {
      this.unternehmen = results.data.message;
    });
  },
  methods: {
    deleteImage(name) {
      this.$store
        .dispatch('deleteImage', {
          userid: this.unternehmen['user_id'],
          id: this.unternehmen.id,
          name,
        })
        .then((result) => {
          this.$store.dispatch('addMessage', {
            message: 'Bild entfernt!',
            type: 'success',
          });
          this.unternehmen[name] = false;
        });
    },
    confirm: function() {
      this.todelete = true;

      setTimeout(
        function() {
          this.todelete = false;
        }.bind(this),
        2000
      );
    },
    deleteConfirm: function() {
      this.$store
        .dispatch('deleteUnternehmen', this.uid)
        .then((results) => {
          this.$store.dispatch('addMessage', {
            message: 'Filiale gelöscht!',
            type: 'success',
          });
          this.$router.push('/admin/unternehmen');
        })
        .catch((err) => {
          this.$store.dispatch('addMessage', {
            message: 'Beim Löschen ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.',
            type: 'error',
          });
        });
    },
    saveUnternehmen: function() {
      if (this.unternehmen.firma && this.unternehmen.firma != '') {
        if (this.unternehmen.new) {
          this.$store
            .dispatch('createUnternehmen', this.unternehmen)
            .then((results) => {
              this.$store.dispatch('addMessage', {
                message: 'Filiale angelegt!',
                type: 'success',
              });
              this.$store.dispatch('loadUnternehmenFromCurrentUser').then((results) => {
                this.unternehmens = results.data.message;
              });
            })
            .catch((err) => {
              this.$store.dispatch('addMessage', {
                message: 'Beim Speichern ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.',
                type: 'error',
              });
            });
        } else {
          this.$store
            .dispatch('saveUnternehmen', this.unternehmen)
            .then((results) => {
              this.$store.dispatch('addMessage', {
                message: 'Gespeichert!',
                type: 'success',
              });
            })
            .catch((err) => {
              this.$store.dispatch('addMessage', {
                message: 'Beim Speichern ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.',
                type: 'error',
              });
            });
        }
      } else {
        this.$store.dispatch('addMessage', {
          message: 'Der Name ihrer Filiale darf nicht leer sein.',
          type: 'error',
        });
      }
    },
    imagepath: function(image) {
      return `${this.$store.state.imagedir}${image}`;
    },
    setBranche: function(value) {
      this.unternehmen.branche = value;
    },
    setBundesland: function(value) {
      this.unternehmen.bezirk = 0;
      this.unternehmen.bundesland = value;
    },
    setBezirk: function(value) {
      this.unternehmen.bezirk = value;
    },
    refreshLogoImage: function(success) {
      if (success.sucess) {
        this.unternehmen.logo = success.file + '?t=' + new Date().getTime();
      }
    },
    refreshHeaderImage: function(success) {
      if (success.sucess) {
        this.unternehmen.header = success.file + '?t=' + new Date().getTime();
      }
    },
  },
  computed: {
    uid: function() {
      return this.$route.params.id;
    },
    branchen: function() {
      return this.$store.getters.allBranchen;
    },
    bundeslaender: function() {
      return this.$store.getters.allBundeslaender;
    },
    bezirke: function() {
      return this.$store.getters.getBezirkeForBundesland(this.unternehmen.bundesland);
    },
  },
});
